import { render } from "./FormAlert.vue?vue&type=template&id=a3f36a20&scoped=true"
import script from "./FormAlert.vue?vue&type=script&lang=js"
export * from "./FormAlert.vue?vue&type=script&lang=js"

import "./FormAlert.vue?vue&type=style&index=0&id=a3f36a20&scoped=true&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f36a20"]])

export default __exports__